// useQueryParam.js
import { useState, useEffect, useCallback } from 'react';

function useQueryParam(paramName) {
  const [ value, setValue ] = useState(() => {
    const params = new URLSearchParams(window.location.search)
    return params.get(paramName)
  });

  // Sync with query param whenever URL might change
  useEffect(() => {
    const updateValue = () => {
      const params = new URLSearchParams(window.location.search);
      setValue(params.get(paramName))
    };

    // Listen for popstate (browser back/forward)
    window.addEventListener('popstate', updateValue)

    // Listen for custom event (when we programmatically change URL)
    window.addEventListener('urlchange', updateValue)

    return () => {
      window.removeEventListener('popstate', updateValue)
      window.removeEventListener('urlchange', updateValue)
    }
  }, [ paramName ])

  const setQueryParam = useCallback((newValue) => {
    const params = new URLSearchParams(window.location.search)

    if (newValue === null || newValue === undefined || newValue === '') {
      params.delete(paramName)
    } else {
      params.set(paramName, newValue)
    }

    const newUrl = params.toString()
      ? `${window.location.pathname}?${params.toString()}`
      : window.location.pathname

    window.history.pushState({}, '', newUrl)

    // Dispatch custom event to notify other hooks
    window.dispatchEvent(new Event('urlchange'))
  }, [ paramName ])

  const clearQueryParam = useCallback(() => {
    setQueryParam(null)
  }, [ setQueryParam ])

  return { value, setQueryParam, clearQueryParam }
}

export default useQueryParam
